window.contentLoaded(window, function (e) {
    var exitInt = document.querySelector('#exit-intent');
    if( !exitInt ) return;

    window.kkScrollTop = 0;
    var time = 0;
    var hasShown = false;
    var onMouse = exitInt.classList.contains('fire-on-mouse');
    var onScroll = exitInt.classList.contains('fire-on-scroll');
    var onTime = exitInt.classList.contains('fire-on-time');
    let isDesktop = window.matchMedia('(min-width: 996px)').matches;
    setTimeout(() => {

            if( onMouse && isDesktop) {
                document.addEventListener('mouseout', mouseEvent);
            }
            if( onScroll ) {
                document.addEventListener('scroll', checkDirection)
            }
            if( onTime && !isDesktop ) {
                setInterval(checkTimer, 1000);
            }

            // Set the timer to 0 if the user interacts
            document.addEventListener('click', resetTimer);
            document.addEventListener('keydown', resetTimer);

            // Hide the popup if the user does anything
            document.addEventListener('keydown', exitEvent);
    }, 1000);

function publishVar () {
    window.dataLayer.push({
        'exitIntentShown': 1
    })
}

function resetTimer() {
    time = 0;
}

function mouseEvent(e) {
    var shouldShowExitIntent = 
        !e.toElement && 
        !e.relatedTarget &&
        e.clientY < 10;
    if (shouldShowExitIntent && !hasShown) {
        document.removeEventListener('mouseout', mouseEvent);
        (new bootstrap.Modal(document.querySelector('#exit-intent'))).show();
        publishVar();
        hasShown = true;
    }
};

function checkTimer() { 
    time++;
    if(time > 14 && !exitInt.classList.contains('show') && !hasShown) {
        (new bootstrap.Modal(document.querySelector('#exit-intent'))).show();
        publishVar();
        hasShown = true;
        time = 0;
    }
}

const checkDirection = debounce(() => {
    var lastPos = window.kkScrollTop;
    var diff = lastPos - (window.pageYOffset | document.body.scrollTop)
    processDirection(diff)
})

const processDirection = (diff) => {
    var tempScroll = (window.pageYOffset | document.body.scrollTop);
    window.kkScrollTop = tempScroll;

    if(diff > 500 && !hasShown) {
        (new bootstrap.Modal(document.querySelector('#exit-intent'))).show();
        publishVar();
        hasShown = true;
        document.removeEventListener('scroll', checkDirection)
    }
} 


function exitEvent(e) {
    (new bootstrap.Modal(document.querySelector('#exit-intent'))).hide();
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

});